/* Action Types */
export const LOAD_ALL_SELLERS_FAIL = 'la/domain/allSellers/LOAD_FAIL';
export const LOAD_ALL_SELLERS_REQUEST = 'la/domain/allSellers/LOAD_REQUEST';
export const LOAD_ALL_SELLERS_SUCCESS = 'la/domain/allSellers/LOAD_SUCCESS';

export const LOAD_SELLERS_FAIL = 'la/domain/sellers/LOAD_FAIL';
export const LOAD_SELLERS_REQUEST = 'la/domain/sellers/LOAD_REQUEST';
export const LOAD_SELLERS_SUCCESS = 'la/domain/sellers/LOAD_SUCCESS';
